import { memo } from 'react';
import cn from 'bem-cn';

import { isExternalURL } from '../../../utils/url';
import { Link, Stack } from '../../UI';

import { useSlideMetrika } from './Slide.hooks';
import { SlideProps } from './Slide.types';
import './Slide.scss';

const b = cn('slide-base');

export const Slide = memo((props: SlideProps) => {
    const { slide, className, controls, isTouch } = props;

    const {
        id,
        backgroundColor,
        imageDesktop,
        imageMobile,
        title,
        titleMobile,
        description,
        descriptionMobile,
        buttonText,
        buttonTextMobile,
        buttonUrl,
    } = slide;
    const visibleTitle = isTouch && titleMobile ? titleMobile : title;
    const visibleDescription = isTouch && descriptionMobile ? descriptionMobile : description;
    const visibleButtonText = isTouch && buttonTextMobile ? buttonTextMobile : buttonText;
    const isDescriptionVisible = Boolean(visibleDescription);
    const isURLExternal = isExternalURL(buttonUrl);
    const image = isTouch ? imageMobile : imageDesktop;

    const reachSlideGoal = useSlideMetrika(id);

    const handleButtonClick = () => {
        reachSlideGoal();
    };

    const style = { '--bg-color': backgroundColor } as React.CSSProperties;

    return (
        <Stack className={b.mix(className)} direction="row" style={style}>
            <Stack className={b('content')}>
                <Stack className={b('content', 'text')}>
                    <h2 className={b('content', 'text', 'title')}>{visibleTitle}</h2>
                    {isDescriptionVisible && (
                        <p className={b('content', 'text', 'description')}>{visibleDescription}</p>
                    )}
                </Stack>
                <Stack className={b('content', 'controls')} direction="row">
                    <Link
                        className={b('content', 'controls', 'button')}
                        to={buttonUrl}
                        external={isURLExternal}
                        onClick={handleButtonClick}
                    >
                        {visibleButtonText}
                    </Link>
                    {controls}
                </Stack>
            </Stack>
            <img className={b('image')} src={image} alt="" />
        </Stack>
    );
});

Slide.displayName = 'Slide';
